import {React, useContext} from 'react';
import {Link} from 'react-router-dom';
import FeedbackSection from './FeedbackSection';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import bg_img from './static/img/bg-img.jpg';
import slide_2 from './static/img/slide2.jpg';
import about_company from './static/img/About-company.png';
import services_item_1 from './static/img/Services_item_1.jpg';
import services_item_2 from './static/img/Services_item_2.jpg';
import services_item_3 from './static/img/Services_item_3.jpg';
import services_item_4 from './static/img/Services_item_4.jpg';
import services_item_5 from './static/img/Services_item_5.jpg';
import services_item_6 from './static/img/Services_item_6.jpg';
import news_example_1 from './static/img/news_example_1.jpg';
import news_example_2 from './static/img/news_example_2.jpg';
import news_example_3 from './static/img/news_example_3.jpg';
import news_example_4 from './static/img/news_example_4.jpg';
import news_example_5 from './static/img/news_example_5.jpg';
import bottom_slider_img_1 from './static/img/bottom_slider_img_1.jpg'
import bottom_slider_img_2 from './static/img/bottom_slider_img_2.jpg';
import OurPartnersSection from './OurPartnersSection';
import ThanksLettersSection from './ThanksLettersSection';
import Slider from "react-slick";
import { RoutesContext } from '../contexts/RoutesContext';


function HomePage(props){

    let routes_context = useContext(RoutesContext);

    let main_slider_settings = {
        autoplay: true,
        infinite: true,
        autoplaySpeed: 3000,
        speed: 950,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        variableWidth: false,
        draggable: true,
      };

      let bottom_slider_settings = {
        autoplay: false,
        infinite: true,
        autoplaySpeed: 3000,
        speed: 950,
        centerMode: false,
        variableWidth: false,
        draggable: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: false,
      };
    
      
      return (

        <main onLoad={routes_context.floating_section_loaded}>
            <div className="main_slider_section">
                <Slider {...main_slider_settings} className="slider_inner_wrapper slick-main-slider">
                    <div className="slider_item_1">
                        <img src={bg_img} alt="" />
                        <div className="slider_1_logo_text">
                            <h2>Planeta barada bilelikde alada edeliň</h2>
                            <h1>“Sagdyn ülke”</h1>
                            <p>Ekologiýa bilen baglanşykly resminamalary işläp düzmek boýunça Services</p>
                            <div className="link_wrapper">
                                <Link to={routes_context.routes.about_company.path} className="btn_animation green">Details</Link>
                            </div>
                        </div>
                    </div>
                    <div className="slider_item_2">
                        <img src={slide_2} alt="" />
                        <div className="slider_2_logo_text">
                            <p>Döwletiň ekologiýa boýunça syýasatynyň esasy wezipesi ilatyň oňaýly daşky gurşawdaky ýaşaýyşyny, has ajaýyp tebigatly ýeri 
                        geljekki nesillere geçirmek üçin, tebigy baýlyklara (resurslara) aýawly çemeleşilmegini we bu baýlyklaryň rejeli ulanylmagyny üpjün etmekden ybaratdyr. 
                        Biz şu ugur boýunça sebit we halkara derejelerinde netijeli hyzmatdaşlygy amala aşyrýarys.
                            </p>
                            <h2>- Gurbanguly Berdimuhamedow</h2>
                        </div>
                    </div>
                </Slider>
            </div>
            <div className="main_slider_mobile ">
                <Slider {...main_slider_settings} className="slider_mobile_inner_wrapper slick-main-slider">
                    <div className="main_slider_item_1_mobile">
                        <h2>Planeta barada bilelikde alada edeliň</h2>
                        <div className="main_slider_img">
                            <img src={bg_img} alt="" />
                            <h1>“Sagdyn ülke”</h1>
                        </div>
                        <p>Ekologiýa bilen baglanşykly resminamalary işläp düzmek boýunça Services</p>
                        <div className="link_wrapper">
                        <Link to={routes_context.routes.about_company.path}><span className="btn_animation green active">Details</span></Link>
                        </div>
                    </div>

                    <div className="main_slider_item_2_mobile">
                        <div className="main_slider_img">
                            <img src={slide_2} alt="" />
                        </div>
                        <div className="item_2_mobile_text_container">
                            <div className="item_2_mobile_text_inner_wrapper">
                                <p>Döwletiň ekologiýa boýunça syýasatynyň esasy wezipesi ilatyň oňaýly daşky gurşawdaky ýaşaýyşyny, has ajaýyp tebigatly ýeri 
                                    geljekki nesillere geçirmek üçin, tebigy baýlyklara (resurslara) aýawly çemeleşilmegini we bu baýlyklaryň rejeli ulanylmagyny üpjün etmekden ybaratdyr. 
                                    Biz şu ugur boýunça sebit we halkara derejelerinde netijeli hyzmatdaşlygy amala aşyrýarys.
                                </p>
                                <h2>- Gurbanguly Berdimuhamedow</h2>
                            </div>
                        </div>

                    </div>
                </Slider>
            </div>
            <div className="floating_section">
                <div className="about_us_section">
                    <div className="inner_wrapper">
                        <img src={about_company} alt="" />
                        <div className="section_2_text_wrapper">
                            <h2>About company</h2>
                            <p><b>“Sagdyn ülke” HK</b> sarp edijilere we kärhanalara biziň planetamyzy <b>geljekki nesiller</b> üçin goraýan jogapkär çözgütleri kabul etmäge mümkinçilik döredýär.</p>
                            <p>Türkmenistanyň Prezidenti Gurbanguly Berdimuhamedowyň Permanyna laýyklykda, <b>“Tebigaty goramak hakyndaky”</b> kanun (Türkmenistanyň Mejlisiniň wedomostlary, 2014 ý., № 1, sah. 40), biziň testirlemek we sertifikasiýa boýunça amallara esaslanýan standartlarymyz sarp edijileriň ýokary howpsuzlygyny kepillendirýär.</p>
                        </div>
                    </div>
                </div>
                <div className="our_services_section">
                    <div className="our_services_title">
                        <h2>Our Services</h2>
                    </div>
                    <div className="our_services_inner_wrapper">
                        <div className="flip_cards_row">
                            <div className="flip_card_container">
                                <div className="flip_card">
                                    <div className="front_side">
                                        <img src={services_item_1} alt="" />
                                        <span className="front_side_description">ENTERPRISE ECOLOGICAL PASSPORT</span>
                                    </div>
                                    <div className="back_side">
                                        <img src={services_item_1} alt="" />
                                        <div className="back_side_inner">
                                            <h2>ENTERPRISE ECOLOGICAL PASSPORT</h2>
                                            <p>Resurslaryň ulanylyşynyň derejesi we onuň önümçiliginiň daşky tebigy gurşawa ýetirýän täsiriniň derejesi baradaky maglumat bar</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flip_card_container">
                                <div className="flip_card">
                                    <div className="front_side">
                                        <img src={services_item_2} alt="" />
                                        <span className="front_side_description">ENTERPRISE ECOLOGICAL PASSPORT</span>
                                    </div>
                                    <div className="back_side">
                                        <img src={services_item_2} alt="" />
                                        <div className="back_side_inner">
                                            <h2>ENTERPRISE ECOLOGICAL PASSPORT</h2>
                                            <p>Islendik kärhananyň ýa-da edaranyň howpsuz hojalyk işiniň hökmany şerti</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flip_card_container">
                                <div className="flip_card">
                                    <div className="front_side">
                                        <img src={services_item_3} alt="" />
                                        <span className="front_side_description">DRAFT OF PERMISSIBLE DISCHARGE NORMS</span>
                                    </div>
                                    <div className="back_side">
                                        <img src={services_item_3} alt="" />
                                        <div className="back_side_inner">
                                            <h2>DRAFT OF PERMISSIBLE DISCHARGE NORMS</h2>
                                            <p>Maddalaryň we mikroorganizmleriň suw obýektlerine akdyrmak üçin rugsat almak maksady bilen işlenip düzülýär</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flip_cards_row">
                            <div className="flip_card_container">
                                <div className="flip_card">
                                    <div className="front_side">
                                        <img src={services_item_4} alt="" />
                                        <span className="front_side_description">DRAFT OF MAXIMUM PERMISSIBLE DISCHARGE</span>
                                    </div>
                                    <div className="back_side">
                                        <img src={services_item_4} alt="" />
                                        <div className="back_side_inner">
                                            <h2>DRAFT OF MAXIMUM PERMISSIBLE DISCHARGE</h2>
                                            <p>Kärhananyň atmosfera çykarýan zyýanly maddalarynyň ylalaşylan konsentrasiýasyny belleýän normatiw</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flip_card_container">
                                <div className="flip_card">
                                    <div className="front_side">
                                        <img src={services_item_5} alt="" />
                                        <span className="front_side_description">ENVIROMENT PROTECTION</span>
                                    </div>
                                    <div className="back_side">
                                        <img src={services_item_5} alt="" />
                                        <div className="back_side_inner">
                                            <h2>ENVIROMENT PROTECTION</h2>
                                            <p>Galyndylaryň howplulygyň kesgitlenen toparyna degişlidigini tassyklaýan resminama</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="flip_card_container">
                                <div className="flip_card">
                                    <div className="front_side">
                                        <img src={services_item_6} alt="" />
                                        <span className="front_side_description">PRODUCTION OF WASTE PASSPORTS</span>
                                    </div>
                                    <div className="back_side">
                                        <img src={services_item_6} alt="" />
                                        <div className="back_side_inner">
                                            <h2>PRODUCTION OF WASTE PASSPORTS</h2>
                                            <p>Kesgitlenen döwürde (kada bolşy ýaly – bir ýylda) tebigatdan peýdalanyjy üçin, galyndylaryň meýilleşdirilýän mukdarlary</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <FeedbackSection />

                <div className="news_section">
                    <div className="news_section_inner_wrapper">
                        <h1 className="news_section_title">News and articles</h1>
                        <div className="news_first_row">
                            <div className="news_card">
                                <img src={news_example_1} alt="" />
                                <div className="news_card_text">
                                    <span className="news_date">09.12.2021</span>
                                    <h3 className="news_title">Türkmenistanda ekologiýa ýagdaýlar kämilleşdirilýär</h3>
                                    <p className="news_content">Türkmenistanyň Oba hojalyk we daşky gurşawy goramak ministrligi we BMG-niň ÖM bilen bilelikde guramagynda «Türkmenistanda durn...</p>
                                    <Link to={routes_context.routes.single_news.path} className="more_button"><span className="btn_animation green">Details</span></Link>
                                </div>
                            </div>

                            <div className="news_card">
                                <img src={news_example_2} alt="" />
                                <div className="news_card_text">
                                    <span className="news_date">23.11.2021</span>
                                    <h3 className="news_title">Türkmenistanyň Kanuny «Ekologiýa howpsuzlygy hakynda» Türkmenistanyň Kanunyna goşmaçalar we üýtgetmeler girizmek hakynda</h3>
                                    <p className="news_content">I. 2017-nji ýylyň 3-nji iýunynda kabul edilen «Ekologiýa howpsuzlygy hakynda» Türkmenistanyň Kanunyna (Tü...</p>
                                    <Link to={routes_context.routes.single_news.path} className="more_button"><span className="btn_animation green">Details</span></Link>
                                </div>
                            </div>

                            <div className="news_card">
                                <img src={news_example_3} alt="" />
                                <div className="news_card_text">
                                    <span className="news_date">23.11.2021</span>
                                    <h3 className="news_title">Türkmenistanyň goraghanalary – bioköpdürlüligiň sakçylary</h3>
                                    <p className="news_content">Türkmenistanda özboluşly ösümlik we haýwanat dünýäsine baý ekologiýa ulgamlarynyň dü...</p>
                                    <Link to={routes_context.routes.single_news.path} className="more_button"><span className="btn_animation green">Details</span></Link>
                                </div>
                            </div>
                        </div>

                        <div className="news_second_row">
                            <div className="news_card_big">
                                <img src={news_example_4} alt="" />
                                <div className="news_card_big_text">
                                    <span className="news_date">14.11.2021</span>
                                    <h3 className="news_title">Plastmassanyň ýerine ekologiýa taýdan arassa we modaly esbaplar</h3>
                                    <p className="news_content">Bütin dünýäniň daşky gurşawy hapalaýan plastika garşy göreşýän häzirki döwründe dü...</p>
                                    <Link to={routes_context.routes.single_news.path} className="more_button"><span className="btn_animation green">Details</span></Link>
                                </div>
                            </div>

                            <div className="news_card_big">
                                <img src={news_example_5} alt="" />
                                <div className="news_card_big_text">
                                    <span className="news_date">07.11.2021</span>
                                    <h3 className="news_title">Milli Liderimiz ählihalk bag ekmek dabarasyna gatnaşdy</h3>
                                    <p className="news_content">6-njy noýabrda hormatly Prezidentimiz Gurbanguly Berdimuhamedowyň gatnaşmagynda ýurdumyzyň şäherleriniň we obalarynyň daş-tö...</p>
                                    <Link to={routes_context.routes.single_news.path} className="more_button"><span className="btn_animation green">Details</span></Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <OurPartnersSection />

                <ThanksLettersSection />

                <div className="bottom_slider_section">
                    <Slider {...bottom_slider_settings} className="bottom_slider_inner_wrapper slick-bottom-slider" >

                        <div className="bottom_slider_item">
                            <div className="slider_item_inner_wrapper">
                                <img src={bottom_slider_img_1} alt="" />
                                <div className="bottom_slider_text">
                                    <h2>Buhara suguny</h2>
                                    <p>Türkmenistanda toýnaklylaryň bu seýrek görnüşi diňe Amyderýa deltasynda gabat gelýär, bu ýerde aborigen populýasiýalar, şeýle emeli toparlar duş gelýär. Geçmişde sugunyň Murgabyň we Tejeniň deltalarynda ýaşandygy baradaky maglumatlar bar.</p>
                                    <p>1982-nji ýylda Amyderýa tebigy goraghanasynyň döredilen soňra ýagdaý gowulanyp ugrady. 1989-1999-njy ýyllarda 30-32 sanysy, 2003-nji ýylda – 46-52; 2011-nji ýylda – 100 sanysy ýaşaýardy. Bu jandarlaryň sanyny gaýtadan köpeltmek üçin 30 ýyldan gowrak wagt zerur bolupdy.</p>
                                    <div className="slider_number">
                                        <span>1</span>
                                        <span>/</span>
                                        <span>2</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="bottom_slider_item">
                            <div className="slider_item_inner_wrapper">
                                <img src={bottom_slider_img_2} alt="" />
                                <div className="bottom_slider_text">
                                    <h2>Ýangi-Gala kanýony</h2>
                                    <p>Balkan welaýatynyň Türkmenbaşy şäherinden 160 kilometr daş aralykda tebigatyň örän gyzykly ýadygärlikleriniň biri – Ýangi-gala ýerleşýär, Ýangi-gala “Otly gala” diýmegi aňladýar. Onuň kert diwarlary her hili reňklidir, gyzyl reňk agdyklyk edýär, onuň ady şondan gelip çykýar.</p>
                                    <p>Haýran galdyrýan we her hili reňkdäki gaýalaryň belentligi 60-100 metre ýetýär. Gije-gündizki wagta we ýagtylandyrylmagyna baglylykda, daglaryň keşbi gözüň alnynda özgerýär. Ýangi-gala kanýony şapakda, daş-töwerekdäki ähli zatlaryň al reňklere&nbsp;boýalanda has-da owadan keşbe eýe bolýar.<br/>
                                        &nbsp;</p>
                                    <div className="slider_number">
                                        <span>2</span>
                                        <span>/</span>
                                        <span>2</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </Slider>
                </div>

            </div>

        </main>


      );
}


export default HomePage